import React from 'react';
import styles from './AlertNotification.module.css';

interface AlertNotificationProps {
  message: string;
  type?: 'success' | 'error';
}

const AlertNotification: React.FC<AlertNotificationProps> = ({
  message,
  type,
}) => {
  if (!message) return null;

  const containerClass = `${styles.popupContainer} ${
    type === 'error' ? styles.error : ''
  }`;

  return <div className={containerClass}>{message}</div>;
};

export default AlertNotification;
